import { useEffect } from 'react';

/**
 * /invite — now a redirect to the canonical invite page.
 *
 * This route used to render a second, hand-maintained copy of the coach
 * site's welcome page (added 2026-09-07). Running two copies of one page
 * meant every improvement landed on only one of them, and the copy that
 * actually received referral traffic was the one nobody was editing. The
 * canonical page is coach.viveka.world/welcome, which now reads ?ref= and
 * carries it through to signup itself.
 *
 * The route is kept rather than removed so that invite links already sent
 * out keep working instead of 404ing.
 *
 * Referral attribution is not affected by the redirect: captureReferralCode()
 * in util/referral.js runs on client bootstrap, so the code is already in
 * localStorage before this component mounts. We also pass it through on the
 * URL so the destination can show the discount to the visitor.
 */

const CANONICAL_URL = 'https://coach.viveka.world/welcome';
const PASS_THROUGH_PARAMS = [
  'ref',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
];

const InvitePage = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    let target = CANONICAL_URL;
    try {
      const incoming = new URLSearchParams(window.location.search);
      const forwarded = new URLSearchParams();
      PASS_THROUGH_PARAMS.forEach(key => {
        const value = incoming.get(key);
        if (value) forwarded.set(key, value);
      });
      const query = forwarded.toString();
      if (query) target = `${CANONICAL_URL}?${query}`;
    } catch (e) {
      // Malformed query string should still not strand the visitor here.
    }

    // replace() so the dead /invite URL does not sit in the back history.
    window.location.replace(target);
  }, []);

  return null;
};

export default InvitePage;
